import { ColDef } from 'ag-grid-enterprise';
import { format } from 'date-fns';
import { Filter, FilterType } from './filter';
import { ClientEnum } from './user';

enum EndpointMethod {
  UNSPECIFIED = 'unspecified',
  GET = 'get',
  POST = 'post',
  DELETE = 'delete',
  PATCH = 'patch',
}

export const METHOD_OPTIONS: EndpointMethod[] = Object.values(EndpointMethod);
export const CLIENT_TYPE_OPTIONS: ClientEnum[] = Object.values(ClientEnum);

export type EndpointMeasure = {
  user_id: string;
  timestamp: string;
  method: EndpointMethod;
  path: string;
  duration: string;
  product: string;
  client_type: ClientEnum;
  ip_address: string;
  whatsapp_number: string;
  whatsapp_command: string;
};

export const ENDPOINT_MEASURES_FILTERS: Filter[] = [
  { type: FilterType.DATETIMERANGE, label: 'Date Range', name: 'date_range' },
  { type: FilterType.TEXTFIELD, name: 'user_id', label: 'User ID' },
  { type: FilterType.AUTOCOMPLETE, name: 'method', label: 'Method', options: METHOD_OPTIONS },
  { type: FilterType.AUTOCOMPLETE, name: 'client_type', label: 'Client Type', options: CLIENT_TYPE_OPTIONS },
];

export const ENDPOINT_MEASURES_COLUMNS: ColDef[] = [
  {
    field: 'user_id',
    headerName: 'User ID',
    cellStyle: { cursor: 'pointer' },
  },
  {
    field: 'method',
    headerName: 'Method',
    valueFormatter: ({ value }) => value?.toUpperCase(),
  },
  {
    field: 'path',
    headerName: 'Path',
    cellClass: 'text-left',
  },
  {
    field: 'timestamp',
    headerName: 'Timestamp',
    valueFormatter: ({ value }) => (value ? format(new Date(value), 'yyyy-MM-dd HH:mm:ss.SSS') : ''),
  },
  {
    field: 'duration',
    headerName: 'Duration',
    valueFormatter: ({ value }) => value?.toFixed(3),
    cellClass: 'text-right',
  },
  {
    field: 'product',
    headerName: 'Product',
    valueFormatter: ({ value }) => value?.toUpperCase(),
  },
  {
    field: 'client_type',
    headerName: 'Client Type',
  },
  {
    field: 'ip_address',
    headerName: 'IP Address',
  },
  {
    field: 'whatsapp_number',
    headerName: 'Whatsapp Number',
  },
  {
    field: 'whatsapp_command',
    headerName: 'Whatsapp Command',
  },
];
